export const stateName = 'businessAddresses' as const
